define('gameday-index-gdscoreboard/GDIndexScoreboardComponent',['require','exports','module','gameday-index-component-base/GDIndexComponentBase','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','app-console/app-console','responsive-gameday-scoreboard/responsive-gameday-scoreboard','Horizontal-Postseason-Scoreboard/src/scripts/core/postseasonGameTypes','gid-decoder/GidDecoder','Horizontal-Postseason-Scoreboard-Build','text!PostseasonTemplate'],function(require, exports, module) {
	// require imports
	var BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
		dispatcher = require("message-service/message-service"),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		logg = require("app-console/app-console"),
		Scoreboard = require('responsive-gameday-scoreboard/responsive-gameday-scoreboard'),
		PostseasonTypes = require('Horizontal-Postseason-Scoreboard/src/scripts/core/postseasonGameTypes'),
		GID = require("gid-decoder/GidDecoder");

	// instance variables
	var Superclass,
		targetDiv,
		regularSb,
		postseasonSb,
		inited = false,
		appConfig = {
		};

	function GDScoreboard(compID, divID) {
		Superclass.init(compID, divID);
		targetDiv = divID;

		/*
		 * Scoreboard is dependent on game_type (regular scoreboard/post-season scoreboard)
		 * wait for GDC data to be loaded before initing. When switching game types, kill old
		 * game model/poller before init-ing new scoreboard
		 */
		dispatcher.addListener.call(this, "init_data_loaded", function() {
			this.buildAppSettings();
			// Don't re-init if its still visible, it'll handle state changes, only re-init if hidden
			if(appConfig.isPostseason() && !$('#GDPostseasonScoreboardContent').is(':visible')) {
				this.initPostseason();
			} else if(!appConfig.isPostseason()) {
				$('#GDPostseasonScoreboardContent').hide();
				$('#GDScoreboardContent').show();
			}
			if(!inited) {
				this.init();
			}
        });
	}

	BaseClass.spawn(GDScoreboard).define({
		init: function() {
			logg.log(targetDiv);

			if(appConfig.isPostseason()) {
				this.initPostseason();
			}
			// Load regular season scoreboard base template
			regularSb = new Scoreboard(targetDiv);
			regularSb.init(appConfig);
			this.initialized = true;
			dispatcher.publish(LoadEvts.componentReady, this.componentID);
			inited = true;
		},

		initPostseason: function() {
			var PostseasonScoreboard = require('Horizontal-Postseason-Scoreboard-Build'),
				postseasonScoreboardTemplate = require('text!PostseasonTemplate');
			// Load post season scoreboard base template
			$('#GDPostseasonScoreboardContent').html(postseasonScoreboardTemplate).promise().done(function(){
				postseasonSb = new PostseasonScoreboard({
					container: '#horizontal-postseason-scoreboard',
					i18n: 'en',
					season: GDC.getGameData().linescore.id.substr(0,4),
					featuredGame: GDC.getGameData().linescore.id
				}); 

				postseasonSb.init();

				postseasonSb.on('setFeaturedGame', function(gid) {
					var gameInfo = GID.decodeGID(gid);
					gameInfo.game_date = gameInfo.gameDateString;
					dispatcher.publish(LoadEvts.updateCalendar, gameInfo);
				});

				this.initialized = true;

				dispatcher.publish(LoadEvts.componentReady, this.componentID);

				$('#GDScoreboardContent').hide();
				$('#GDPostseasonScoreboardContent').show();
			});
		},

		buildAppSettings: function() {
			appConfig.game_type = GDC.getGameData().linescore.game_type;
			appConfig.isPostseason = function() {
				for (var prop in PostseasonTypes) {
					if(appConfig.game_type !== "R" && PostseasonTypes[prop] == appConfig.game_type) {
						return true;
					}
				}
				return false;
			}
		}
	});

	Superclass = GDScoreboard.superclass;
	return GDScoreboard;
});
